import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { injectIntl, IntlShape } from 'react-intl';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';

import { AssuranceIcon } from 'images';
import messages from 'containers/AgentPage/messages';
import { translate } from 'helpers/intl';
import {
  StyledCaptions,
  StyledCaptionsTitle,
} from 'components/AgentInfo/BodyAgentInfo/style';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { reversedNum } from 'utils/string';
import { StyledLink } from 'containers/MRhDashboard/services/styles';
import { useMediaQuery, useTheme } from '@material-ui/core';

interface BodyAgentInfoProps {
  intl: IntlShape;
  horaireLundiJeudi: string;
  horaireVendredi: string;
  horaireSamedi: string;
  phone: string;
  email: string;
}

const BodyAgentInfo = (props: BodyAgentInfoProps) => {
  const hasHoraire =
    !isEmpty(props.horaireLundiJeudi) ||
    !isEmpty(props.horaireVendredi) ||
    !isEmpty(props.horaireSamedi);
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box py={3}>
      <Grid container direction="column" spacing={1}>
        {hasHoraire && (
          <Grid item xs={matches ? 12 : 7}>
            <Grid container spacing={4}>
              <Grid item xs={1}>
                <img alt="" src={AssuranceIcon['HoraireIcon']} />
              </Grid>
              <Grid item xs={7}>
                <StyledCaptionsTitle color="#0880BC" weight="500">
                  {translate({ ...messages.AgentHoraireTitle }, props)}
                </StyledCaptionsTitle>
              </Grid>
            </Grid>
            <Box px={3}>
              <Grid container>
                <Grid item xs={4}>
                  <StyledCaptions weight="500">
                    {translate({ ...messages.AgentLundiJeudi }, props)}
                  </StyledCaptions>
                </Grid>
                <Grid item xs={8}>
                  <StyledCaptions weight="300">
                    {props.horaireLundiJeudi}
                  </StyledCaptions>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={3}>
                  <StyledCaptions weight="500">
                    {translate({ ...messages.AgentVendredi }, props)}
                  </StyledCaptions>
                </Grid>
                <Grid item xs={8}>
                  <StyledCaptions weight="300">
                    {props.horaireVendredi}
                  </StyledCaptions>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={3}>
                  <StyledCaptions weight="500">
                    {translate({ ...messages.AgentSamedi }, props)}
                  </StyledCaptions>
                </Grid>
                <Grid item xs={8}>
                  <StyledCaptions weight="300">
                    {props.horaireSamedi}
                  </StyledCaptions>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        )}
        {props.phone && (
          <Grid item xs={matches ? 12 : 6}>
            <Grid container spacing={4}>
              <Grid item xs={1}>
                <img alt="" src={AssuranceIcon['PhoneIcon']} />
              </Grid>
              <Grid item xs={7}>
                <StyledCaptionsTitle color="#0880BC" weight="500">
                  {translate({ ...messages.AgentPhone }, props)}
                </StyledCaptionsTitle>
              </Grid>
            </Grid>
            <Box px={4.5}>
              <StyledLink href={`tel:${props.phone}`}>
                <StyledCaptions weight="500">
                  {reverse ? reversedNum(props.phone) : props.phone}
                </StyledCaptions>
              </StyledLink>
            </Box>
          </Grid>
        )}
        {props.email && (
          <Grid item xs={6}>
            <Grid container spacing={4}>
              <Grid item xs={1}>
                <img alt="" src={AssuranceIcon['EmailIcon']} />
              </Grid>
              <Grid item xs={7}>
                <StyledCaptionsTitle color="#0880BC" weight="500">
                  {translate({ ...messages.AgentEmail }, props)}
                </StyledCaptionsTitle>
              </Grid>
            </Grid>
            <Box px={4.5}>
              <StyledCaptions weight="500">
                <a
                  href={`mailto: ${props.email}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {props.email}
                </a>
              </StyledCaptions>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default injectIntl(BodyAgentInfo);
